export default "__VITE_ASSET__BX6WkJI4__"